import moment from 'moment'

/**
* @description Change date to specific format
* @param date String describing date to be formated
* @param format Desired format of the date
*/
export function formatDate (date, format) {
  return moment(date).format(format)
}

/**
* @description Enable/Disable scroll on components send by param
* @param enabled Is the scroll enable or no
* @param refs References to the components which scroll needs to be disable
*/
export function toggleRefScroll (enabled, refs) {
  refs.forEach((ref) => {
    ref.style.overflow = enabled ? 'auto' : 'hidden'
  })
}

/**
 * @description Get the formatted date difference between a given date and current time
 * @param date Date to compare with current time
 */
export function formatTimeAgo (date) {
  const previousDate = moment(date)
  const currentDate = moment()
  const intervals = ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds']
  const preciseDateDiff = {}

  for (let index = 0; index < intervals.length; index++) {
    const difference = currentDate.diff(previousDate, intervals[index])
    preciseDateDiff[intervals[index]] = difference
    previousDate.add(difference, intervals[index])
  }
  return dateDiffPersonalized(preciseDateDiff)
}

/**
 * @description Format intervals date difference in a personalized way
 * @param dateDiff Object with intervals date difference
 */
function dateDiffPersonalized (dateDiff) {
  let diffFormatted = ''
  if (dateDiff.years && dateDiff.months) {
    diffFormatted = formatLabel(dateDiff.years, 'year') + ', ' + formatLabel(dateDiff.months, 'month')
  } else if (dateDiff.months) {
    diffFormatted = formatLabel(dateDiff.months, 'month')
  } else if (dateDiff.weeks) {
    diffFormatted = formatLabel(dateDiff.weeks, 'week')
  } else if (dateDiff.days) {
    diffFormatted = dateDiff.days > 1 ? formatLabel(dateDiff.days, 'day') : 'Yesterday'
  } else if (dateDiff.hours) {
    diffFormatted = formatLabel(dateDiff.hours, 'hour')
  } else if (dateDiff.minutes) {
    diffFormatted = formatLabel(dateDiff.minutes, 'minute')
  } else {
    diffFormatted = formatLabel(dateDiff.seconds, 'second')
  }
  return diffFormatted + (diffFormatted === 'Yesterday' ? '' : ' ago')
}

/**
 * @description Get label information about date difference
 * @param number Number of interval
 * @param singularLabel Name of the interval
 */
function formatLabel (number, singularLabel) {
  return number + ' ' + singularLabel + (number > 1 ? 's' : '')
}

/**
 * @description Gets the iOS version of iphone
 */
export function iOSVersion () {
  const userAgent = window.navigator.userAgent.toLowerCase()
  return userAgent.includes('iphone') && Number(userAgent.substr(userAgent.indexOf('version/') + 8, 2))
}

/**
 * @description Check if is mobile devive
 */
export function isMobile () {
  return navigator.userAgent.match(/Android|iPhone|iPad/i)
}

/**
 * @description Check if is mobile resolution
 */
 export function isMobileResolution () {
  return window.innerWidth < 768
}
